import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Route guard that only allows Super Admin / Administrator users.
 * Even if a company user manually enters /super-admin/*, access is denied.
 */
export default function SuperAdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#0f172a', color: '#94a3b8',
        fontFamily: "'Inter', sans-serif",
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner" />
          <p style={{ marginTop: 12, fontSize: 13 }}>Verifying access...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/super-admin/login" replace />;

  // Company admins have company_id → blocked from superadmin portal
  const isPlatformAdmin = !user.company_id && (user.id === 1 || ['Administrator', 'Superadmin'].includes(user.role_name));
  if (!isPlatformAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
